import React from "react";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import PrivateContactPage from "./PrivateContactPage";
import { useTheme } from "../context/ThemeContext";
import SEOHead from "../components/seo/SEOHead";
import BreadcrumbSchema from "../components/seo/BreadcrumbSchema";
import LocalBusinessSchema from "../components/seo/LocalBusinessSchema";

const ContactPage = () => {
  const { isDarkMode } = useTheme();
  return (
    <div className={`flex flex-col min-h-screen ${isDarkMode ? 'bg-gray-900' : 'bg-white'}`}>
      <SEOHead title="Contact Us" description="Get in touch with us. We'd love to hear from you." />
      <BreadcrumbSchema items={[{ name: "Contact", path: "/contact" }]} />
      <LocalBusinessSchema />
      <Navbar transparent={true} />
      {/* Hero Section */}
      <section className={`relative ${isDarkMode ? 'bg-gray-800' : 'bg-gray-700'} text-white`}>
        {/*!fromHeader && (
          <section className="relative bg-gray-700 text-white">
            <div className="container mx-auto px-6 py-8 relative z-10"></div>
          </section>
        ) */}
        <div className={isDarkMode ? 'bg-gray-900' : 'bg-white'}>
          <PrivateContactPage />
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;
